import i18next from 'i18next';
import { percent } from '../helpers';
import { type UsageChartData } from './types';

export const usageChartData = (theme: any) => (data: UsageChartData) => ({
  title: `${i18next.t('historical use', { ns: 'overview' })}: ${i18next.t('common:capitalize', {
    value: i18next.t('common:payflow')
  })}`,
  data: [
    {
      id: 'register',
      label: i18next.t('are registered', { ns: 'overview' }),
      legend: i18next.t('common:capitalize', { value: i18next.t('registered', { ns: 'overview' }) }),
      color: [theme.palette.colorPalette[1], theme.palette.colorPalette[2]],
      value: percent(data?.activeCount, data?.totalCount) || 0
    },
    {
      id: 'usage',
      upperLabel: i18next.t('of registered', { ns: 'overview' }),
      label: i18next.t('withdrawn', { ns: 'overview' }),
      legend: i18next.t('common:capitalize', { value: i18next.t('withdrawn', { ns: 'overview' }) }),
      color: [theme.palette.colorPalette[3], theme.palette.colorPalette[2]],
      value: percent(data?.hasWithdrawnCount, data?.activeCount) || 0
    }
  ]
});
